import React, { useState, useEffect, useContext } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Row } from 'primereact/row';
import { ColumnGroup } from 'primereact/columngroup';
import { Home_context } from '../../context/home_context';

export default function Suppliers_page() {
  const { report_data_state } = useContext(Home_context);
let dummy_data = [
  {
    suppliers: 'Ashland',
    commercial_grades: report_data_state?.report_data['rm_name_en'],
  },
];
  return (
    <div className="card report_id_tables">
      <p className="page_headers  font-semibold text-start pt-2 header_color">
        SUPPLIERS
      </p>
      <DataTable
        value={dummy_data}
        showGridlines
        className="page_table_font_size"
      >
        <Column className="w-[20rem]" field="suppliers" header="Suppliers" />
        <Column
          className="w-[20rem]"
          field="commercial_grades"
          header="Commercial Grades"
        />
      </DataTable>
    </div>
  );
}
